import { useCookies } from 'react-cookie';
export interface GridManagerFieldItem {
  id: string;
  column: string;
  type: string;
  gridAvailability: boolean;
  visibility: boolean;
  fieldName: string;
  order: number;
}

export interface GridColCommon {
    id: string;
    [key: string]: any;
  }

export const sortFn = (a: any, b: any) => {
  return a.order - b.order;
};


 export const isISODateString = (value: any): boolean => {
    // Regex pattern for ISO 8601 date format
    const isoDatePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?Z$/;
    return typeof value === "string" && isoDatePattern.test(value);
  };

 export function formatDate(datestring: string) {
    const currentDate = new Date(datestring);
    const day = currentDate.getDate().toString().padStart(2, "0");
    const monthName = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthName[currentDate.getMonth()];
    const year = currentDate.getFullYear();
    return `\t${day}/${month}/${year}`;
  }


 export const handleMenuDataValue = (originName: string): string => {
      return originName
        .replace(/[\\/-]/g, "")
        .split(/\s+/)
        .map((word, index) =>
          index === 0
            ? word.charAt(0).toLowerCase() + word.slice(1)
            : word.charAt(0).toUpperCase() + word.slice(1)
        )
        .join("");
    };

  export const getAllIds = (tree: any, result: any) => {
  if (!Array.isArray(tree)) return [];
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    result.push(node.id);
    if (Array.isArray(node.children)) {
      getAllIds(node.children, result);
    }
  }
  return result;
}

export const canParseToJson = (str: any) => {
  if (typeof str == 'string') {
    try {
      let obj = JSON.parse(str);
      if (typeof obj == 'object' && obj) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }
}



export function firstWordCase(parameter: string) {
  return parameter.slice(0, 1).toUpperCase() + parameter.slice(1).toLowerCase();
}



export const formName = "xEVMPD";
export const module = "xevmpd";

export const transformFormDataForReset = (
  formData: any, 
  formFields: any[], 
  relatedData?: any
) => {
  if (!formData) return formData;

  const transformedData = { ...formData };
  if (!Array.isArray(formFields)) return transformedData;

  formFields.forEach((field: any) => {
    // Handle attachment field
    if (field.field === "attachment" && !formData[field.field]) {
      return;
    }
    
    // Handle radio fields - take everything from relatedData
    if (field.type === "radio" && relatedData?.[field.field] !== undefined) {
      const relatedFieldValue = relatedData[field.field];
      
      // For radio, we want the value (not label-value object)
      // Radio fields typically have string/number values
      transformedData[field.field] = relatedFieldValue;
      return;
    }
    
    // Handle select fields - label from cellData, value from relatedData
    if (field.type === "select" && formData[field.field] !== undefined) {
      const fieldValue = formData[field.field];
      const relatedFieldValue = relatedData?.[field.field];

      // Skip if already null/undefined
      if (fieldValue === null || fieldValue === undefined) {
        return;
      }

      // Handle multi-select fields
      if (field.multiple === true) {
        // Initialize as empty array if value is falsy
        if (!fieldValue) {
          transformedData[field.field] = [];
          return;
        }

        // If it's already an array of objects with value property, check if we need to update
        if (Array.isArray(fieldValue)) {
          const isProperlyFormatted = fieldValue.length === 0 || 
            fieldValue.every(
              (item: any) => 
                item && 
                typeof item === "object" && 
                "value" in item && 
                "label" in item
            );
          
          if (isProperlyFormatted && relatedFieldValue !== undefined) {
            // Update values from relatedData while keeping labels
            transformedData[field.field] = fieldValue.map((item: any, index: number) => {
              const newValue = Array.isArray(relatedFieldValue) 
                ? relatedFieldValue[index] 
                : relatedFieldValue;
              return {
                ...item,
                value: newValue !== undefined ? newValue : item.value,
              };
            });
            return;
          } else if (isProperlyFormatted) {
            // Already properly formatted, no related data
            return;
          }
          
          // Get related values (could be array or single value)
          let relatedValues: any[] = [];
          if (Array.isArray(relatedFieldValue)) {
            relatedValues = relatedFieldValue;
          } else if (relatedFieldValue !== undefined) {
            relatedValues = [relatedFieldValue];
          }
          
          // Transform array: use label from cellData, value from relatedData
          transformedData[field.field] = fieldValue.map((item: any, index: number) => {
            // Get value from relatedData if available, otherwise use item
            const value = relatedValues[index] !== undefined ? relatedValues[index] : item;
            return {
              label: String(item), // Label from cellData
              value: value, // Value from relatedData
            };
          });
        } 
        // Handle comma-separated string
        else if (typeof fieldValue === "string") {
          const labels = fieldValue
            .split(",")
            .map((v: string) => v.trim())
            .filter(Boolean);
          
          // Get related values
          let relatedValues: any[] = [];
          if (Array.isArray(relatedFieldValue)) {
            relatedValues = relatedFieldValue;
          } else if (typeof relatedFieldValue === "string") {
            relatedValues = relatedFieldValue.split(",").map(v => v.trim());
          } else if (relatedFieldValue !== undefined) {
            relatedValues = [relatedFieldValue];
          }
          
          transformedData[field.field] = labels.map((label: any, index: number) => ({
            label: String(label), // Label from cellData
            value: relatedValues[index] !== undefined ? relatedValues[index] : label, // Value from relatedData
          }));
        }
        // Handle single value (wrap in array)
        else {
          transformedData[field.field] = [{
            label: String(fieldValue), // Label from cellData
            value: relatedFieldValue !== undefined ? relatedFieldValue : fieldValue, // Value from relatedData
          }];
        }
        return;
      }
      
      // Handle single select fields
      if (
        fieldValue &&
        typeof fieldValue === "object" &&
        "value" in fieldValue &&
        "label" in fieldValue
      ) {
        // Already properly formatted, but we might want to update value from relatedData
        if (relatedFieldValue !== undefined) {
          transformedData[field.field] = {
            ...fieldValue, // Keep existing object properties (especially label)
            value: relatedFieldValue, // Update value from relatedData
          };
        }
        return;
      }

      // Transform string/number to object with merged data
      if (typeof fieldValue === "string" || typeof fieldValue === "number") {
        transformedData[field.field] = {
          label: String(fieldValue), // Label from cellData
          value: relatedFieldValue !== undefined ? relatedFieldValue : fieldValue, // Value from relatedData
        };
      }
    }
  });

  return transformedData;
};


export function useAppCookies() {
  const [cookies] = useCookies(['USER_TENANT_ID', 'DOMAIN','ACCESS_TOKEN', 'USER_NAME', 'USER_ID']);
  const tenantID = cookies.USER_TENANT_ID;
  const userName = cookies.USER_NAME ?? 'ABC';
  const userID = cookies.USER_ID;
  const token = cookies.ACCESS_TOKEN;
  const domain = "All";
  return { tenantID, userName, cookies, userID, token,domain};
}

export const getTruncatedName = (name: string, limit = 30) =>
  name?.length > limit ? `${name.substring(0, limit)}...` : name;


export const toArray = (value: any) => {
  return Array.isArray(value) ? value : [value];
};

export const extractVersion = (versionString : any) => {
  if (!versionString) {
    return { major: 0, minor: 0 };
  }
  
  // Remove 'V' or 'v' prefix and split by dot
  const parts = versionString.replace(/^[Vv]/, '').split('.');
  
  return {
    major: parseInt(parts[0]) || 0,
    minor: parseInt(parts[1]) || 0
  };
};